var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"\n\t\tionicons-v5-a\n\t"),React.createElement("polyline",{"points":"268 112 412 256 268 400","style":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48px"},"key":1}),React.createElement("line",{"x1":"392","y1":"256","x2":"100","y2":"256","style":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48px"},"key":2})]);
}

ArrowForward.defaultProps = {"viewBox":"0 0 512 512","fill":"none","stroke":"currentColor"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
